<template>
  <div class="mb-4">
    <div class="form-head mb-3">رسوم خدمة التقبيل</div>
    <div class="row">
      <div class="col-12 col-sm-6 mb-3">
        <label class="form-label">رسوم الخدمة:</label>
        <div v-if="fee != null">{{ fee }} ريال <span v-if="fee === 0" class="badge bg-secondary">مجاني</span></div>
        <div v-else class="text-body-secondary">لم تُحدد بعد</div>
      </div>
      <div v-if="dataRow && fee > 0" class="col-12 col-sm-6 mb-3">
        <label class="form-label">حالة السداد:</label>
        <div><span :class="dataRow.isPaid ? 'badge bg-success' : 'badge bg-warning text-dark'">{{ dataRow.isPaid ? 'تم السداد' : 'بانتظار السداد' }}</span></div>
      </div>
      <template v-if="hasCoupon">
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">كود الكوبون:</label>
          <div>{{ dataRow.couponCode || (dataRow.Coupon && dataRow.Coupon.code) || 'غير متوفر' }}</div>
        </div>
        <div v-if="dataRow.couponTitle || (dataRow.Coupon && dataRow.Coupon.title)" class="col-12 col-sm-6 mb-3">
          <label class="form-label">اسم الكوبون:</label>
          <div>{{ dataRow.couponTitle || dataRow.Coupon.title }}</div>
        </div>
        <div v-if="dataRow.couponType" class="col-12 col-sm-6 mb-3">
          <label class="form-label">نوع الخصم:</label>
          <div>{{ dataRow.couponType === 'percentage' ? 'نسبة مئوية' : 'قيمة ثابتة' }}</div>
        </div>
        <div v-if="dataRow.couponAmount != null" class="col-12 col-sm-6 mb-3">
          <label class="form-label">قيمة خصم الكوبون:</label>
          <div>{{ dataRow.couponAmount }} {{ dataRow.couponType === 'percentage' ? '٪' : 'ريال' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">حالة الكوبون:</label>
          <div><span :class="dataRow.couponAccepted ? 'badge bg-success' : 'badge bg-warning text-dark'">{{ dataRow.couponAccepted ? 'مطبق' : 'لم يطبق' }}</span></div>
        </div>
        <div v-if="dataRow.priceAfterDiscount != null" class="col-12 col-sm-6 mb-3">
          <label class="form-label">رسوم الخدمة بعد الخصم:</label>
          <div>{{ dataRow.priceAfterDiscount }} ريال</div>
        </div>
      </template>
      <div v-if="dataRow && dataRow.paymentId" class="col-12 col-sm-6 mb-3">
        <label class="form-label">عملية الدفع:</label>
        <router-link :to="`/payments/update/${dataRow.paymentId}`">#{{ dataRow.paymentId }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExchangePaymentDetails',
  props: {
    dataRow: {type: Object, default: null},
    servicePrice: {type: Number, default: null},
  },
  computed: {
    fee(){
      const price = this.dataRow ? this.dataRow.servicePrice : this.servicePrice;
      return price == null ? null : Number(price);
    },
    hasCoupon(){
      return this.dataRow && (this.dataRow.couponId || this.dataRow.Coupon || this.dataRow.couponCode || this.dataRow.couponType);
    },
  },
}
</script>
